import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export interface StorageUsage {
  usedBytes: number
  quotaBytes: number | null
  isAdmin: boolean
  percentUsed: number
}

export interface StoragePlan {
  id: string
  label: string
  bytes: number
  price: number
}

export function useStorageUsage() {
  return useQuery<StorageUsage>({
    queryKey: ['storage-usage'],
    queryFn: () => api.get('/storage/usage'),
  })
}

export function useStoragePlans() {
  return useQuery<StoragePlan[]>({
    queryKey: ['storage-plans'],
    queryFn: () => api.get('/storage/plans'),
    enabled: false, // only fetch when dialog opens
  })
}

export function usePurchaseStorage() {
  const qc = useQueryClient()
  return useMutation<{ ok: boolean; billingUrl: string }, Error, string>({
    mutationFn: (planId: string) => api.post('/storage/purchase', { planId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['storage-usage'] }),
  })
}
